import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import { DataEventProps } from "../../../../libraries/wpl/foundations/src/index";

export interface ProductNavLinkProps {
    label: string; // header link text
    href: string; // link
    isSelected?: boolean;
    dataEventProps?: DataEventProps;
}

const linkStyle = css({
    "& a": {
        position: "relative",
        insetBlockStart: "3px",
        display: "block",
        fontSize: "1rem",
        lineHeight: 1,
        [media.above.md]: {
            "margin": `0 ${token("space.200")}`,
            "padding": `${token("space.200")} 0`,
            "color": "#0052cc",
            "boxSizing": "border-box",
            "borderBlockEnd": "3px solid white",
            "textDecoration": "none",
            "&:hover": {
                borderBlockEnd: "3px solid #dfe1e5",
                color: "rgb(0, 101, 255)"
            }
        },
        [media.below.md]: {
            "width": "100%",
            "padding": `${token("space.200")} 10px`,
            "margin": `0 ${token("space.200")}`,
            "color": "#0052cc",
            "insetInlineEnd": "10px",
            "textDecoration": "underline",
            "&:hover": {
                textDecoration: "none",
                color: "rgb(0, 101, 255)",
                boxSizing: "border-box",
                backgroundColor: "#ebecf0"
            }
        }
    },
    ".selected": {
        fontWeight: 600,
        [media.above.md]: {
            "borderBlockEnd": "3px solid #0053cc",
            "&:hover": {
                borderBlockEnd: "3px solid #0053cc"
            }
        }
    }
});

export const ProductNavLink = (props: ProductNavLinkProps) => {
    return (
        <div css={linkStyle}>
            <a
                className={props.isSelected ? "selected" : ""}
                href={props.href}
                {...props.dataEventProps}
                data-label={props.label}
            >
                {props.label}
            </a>
        </div>
    );
};

export default ProductNavLink;
